import * as tslib_1 from "tslib";
import { KeyControlAndAbstractSearchCriteria } from './key-control-and-abstract-search-criteria';
var CompanySearchCriteria = /** @class */ (function (_super) {
    tslib_1.__extends(CompanySearchCriteria, _super);
    function CompanySearchCriteria() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.code = '';
        _this.name = '';
        return _this;
    }
    return CompanySearchCriteria;
}(KeyControlAndAbstractSearchCriteria));
export { CompanySearchCriteria };
